module.exports = __webpack_public_path__ + "img/ic-line.2e7e74f0.svg";